import { lazy } from "react";
import OnboardingRoute from "../../_features/onboarding/OnboardingRoute";
import { paths } from "./paths";

const SignIn = lazy(() => import("../../_features/auth/pages/SignIn"));
const AccessDenied = lazy(() => import("./ForbiddenPage"));
const OnboardingPage = lazy(() => import("../../_features/onboarding"));
const LaunchFlow = lazy(() => import("../../_features/launchFlow/pages/LaunchFlowPage"));
const SelfServeCheckout = lazy(() => import("../../_features/selfServeCheckout/pages/SelfServeCheckoutPage"));
const Pay = lazy(() => import("../../_features/pay/pages/PayPage"));
const StripePaymentSuccess = lazy(() => import("../../_features/stripeResult/pages/StripeSuccessPage"));
const StripePaymentFailure = lazy(() => import("../../_features/stripeResult/pages/StripeFailurePage"));
const OrganizationSelection = lazy(() => import("../../_features/auth/pages/OrganisationSelection"));

export const authRoutes = [
    { path: paths.signIn, element: <SignIn /> },
    { path: "/forbidden", element: <AccessDenied /> },
    {
        element: <OnboardingRoute />,
        children: [
            { path: paths.onboarding, element: <OnboardingPage /> },
        ]
    },
    { path: "/launchFlow", element: <LaunchFlow /> },
    { path: "/selfservecheckout", element: <SelfServeCheckout /> },
    { path: "/pay", element: <Pay /> },
    { path: "/stripe-success", element: <StripePaymentSuccess /> },
    { path: "/stripe-failure", element: <StripePaymentFailure /> },
    { path: paths.orgSelect, element: <OrganizationSelection /> },
];
